import React, { useEffect, useState } from "react"
import { BidModel } from "../../../models/bid/BidModel"
import "./ChangeMarket.scss"
import { t } from "i18next"
type Props = {
    bids: BidModel[]
    onSelectedBid: any
    style?: React.CSSProperties
}

export function ChangeMarket({ bids, onSelectedBid, style }: Props) {

    const [selectedBid, setSelectedBid] = useState(bids[0])

    function isSelected(b: BidModel) {
        return b.market_day === selectedBid.market_day
    }

    useEffect(() => {
        onSelectedBid(selectedBid)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBid])

    return <div className="pempem-flex-row" style={{ ...style ,position: "relative" }} >
        <div style={{ border: '2px solid grey', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, zIndex:0 }}></div>
        {
            bids.map((b, index) => {
                return <div key={`${b.id}/${b.market_day}/${index}`}
                    className={`pempem-flex-row-center padding10 pointer ${isSelected(b) ? 'markerSelected' : ''}`}
                    style={{ flex: 1, zIndex:1 }}
                    onClick={() => setSelectedBid(b)}>
                    <p>{index === 0 ? t('today') : index === 1 ? t('tomorrow') : ""} ({b.market_day})</p>
                </div>
            })
        }
    </div>
}